<template>
	<div class="ss-content map-detail-content">
		<div class="venue-info">
			<div class="ss-container">
				<div class="venue-img">
					<img :src="BASE_URL() + articleData.attrs.listPic" />
				</div>
				<div class="venue-content">
					<div class="venue-info-top">
						<p class="venue-title">{{articleData.title}}</p>
						<div class="venue-address">
							<div class="fr">
								<div class="venue-star">
									<div class="venue-star-item" v-for="item in 5" :key="item">
										<img v-if="item <= otherInfo.integral" src="../../assets/img/culturalMap/star-active.png" />
										<img v-else src="../../assets/img/culturalMap/star.png" />
									</div>
									<span>{{otherInfo.integral | price}}</span>
								</div>
							</div>
							{{articleData.attrs && articleData.attrs.address}}
						</div>
					</div>
					<div class="venue-info-bottom">
						<template v-if="articleData.attrs">
							<div class="venue-text">开放时间：{{articleData.attrs.openTime | time('sort')}} - {{articleData.attrs.endTime | time('sort')}}</div>
							<div class="venue-text">电话：{{articleData.attrs.telephone}}</div>
						</template>
						<div class="venue-tool">
							<div class="tool-item tool-item__collect" :class="{'tool-item__active': toolObj.isCollect}" @click="collection()">收藏</div>
							<div class="tool-item tool-item__like" :class="{'tool-item__active': toolObj.isUp}" @click="resourceUp()">点赞</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="activity-detail-content ss-container">
			<div class="activity-detail__left">
				<ul class="activity-detail__menu" v-if="typeList.length > 1">
					<li v-for="(item, index) in typeList" @click="changeType(index)" :class="{active: typeIndex === index}" :key="index">{{item.label}}</li>
				</ul>
				<div class="activity-detail__tab">
					<div class="activity-detail__content" :class="{'activity-detail__content_active': typeIndex === 0}">
						<div class="article__html" v-html="articleData.txt"></div>
					</div>
					<div class="activity-detail__content publish__content" :class="{'activity-detail__content_active': typeIndex === 1}">
						<ssTrainList :value="curData_" :finish="finish_" :busy="busy_" mode="3" />
					</div>
					<div class="activity-detail__content publish__content" :class="{'activity-detail__content_active': typeIndex === 2}">
						<ssTrainList :value="curData_" :finish="finish_" :busy="busy_" mode="4" />
					</div>
          <div class="activity-detail__content publish__content" :class="{'activity-detail__content_active': typeIndex === 3}">
            <ssCommentList/>
          </div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ssTrainList from '@/components/ss-train-list/ss-train-list.vue'
	import articleDetailMixin from '@/mixins/articleDetail.js'
	import listMixin from '@/mixins/list.js'
  import {BASE_URL, PROXY_NAME} from "@/config";
  import ssCommentList from "@/components/ss-comment-list/ss-comment-list.vue";
	export default {
		mixins: [ articleDetailMixin, listMixin ],
		components: {
      ssCommentList,
			ssTrainList
		},
		data() {
			return {
				typeIndex: 0,
				typeList: [{
					label: '场馆介绍',
					value: 1
				}, {
					label: '活动资讯',
					value: 'bghdzx'
				}, {
					label: '风采展示',
					value: 'bgfczs'
				}, {
					label: '讨论区',
					value: 3
				}],
				isAuto: false,
				otherInfo: {}
			}
		},
		created() {
			this.getVenueInfoByContentId();
		},
		methods: {
      BASE_URL() {
        return BASE_URL
      },
			async getVenueInfoByContentId() {
				let res = await this.$http('getVenueInfoByContentId', {
					contentId: this.contentId
				})
				if(res.code === 1){
					this.otherInfo = res.data;
					if(this.otherInfo.level >= 4){
						this.typeList.splice(1,2);
					}
				}
				console.log(res);
			}
		}
	}
</script>

<style lang="scss">
	@import '~@/assets/css/activity-detail.scss';
	.map-detail-content{
		padding-bottom: 70px;
		.venue-info{
			background-color: #fff;
			padding: 55px 0 38px;
			.venue-info-bottom{
				padding-top: 15px;
				border-top: 1px solid #E4E4E4;
				.venue-text{
					font-size: 16px;
					font-weight: 400;
					color: #777777;
					line-height: 30px;
				}
				.venue-tool{
					margin-top: 30px;
					.tool-item{
						cursor: pointer;
						margin-right: 30px;
						font-size: 16px;
						font-weight: 400;
						color: #B6CFED;
						display: inline-block;
						line-height: 30px;
						height: 30px;
						padding-left: 37px;
						background: left top / 27px auto no-repeat;
						&.tool-item__collect{
							background-image: url(../../assets/img/culturalInfo/collection.png);
						}
						&.tool-item__like{
							background-image: url(../../assets/img/culturalInfo/dianzan.png);
						}
						&.tool-item__active{
							&.tool-item__collect{
								background-image: url(../../assets/img/culturalInfo/collection_sel.png);
							}
							&.tool-item__like{
								background-image: url(../../assets/img/culturalInfo/dianzan_sel.png);
							}
						}
					}
				}
			}
			.venue-content{
				width: 840px;
				padding: 15px 0  0 30px;
				float: right;
				.venue-address{
					margin-top: 26px;
					font-size: 16px;
					font-weight: 400;
					color: #777777;
					line-height: 30px;
					.venue-star{
						.venue-star-item{
							display: inline-block;
						}
						img{
							width: 16px;
							height: 16px;
							display: inline-block;
							vertical-align: middle;
							margin-right: 3px;
						}
						span{
							font-size: 14px;
							font-weight: 400;
							color: #727272;
							line-height: 16px;
							padding-left: 5px;
							display: inline-block;
							vertical-align: middle;
						}
					}
				}
				.venue-title{
					font-size: 20px;
					font-weight: 400;
					color: #202A30;
					line-height: 30px;
				}
			}
			.venue-img{
				width: 360px;
				float: left;
				img{
					width: 100%;
					display: block;
				}
			}
		}
	}
</style>
